import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const AllRoundApproach = lazyWithPreload(
  () => import('./AllRoundApproach'),
)
